import { render, staticRenderFns } from "./PayCollection.vue?vue&type=template&id=a561143e&"
import script from "./PayCollection.vue?vue&type=script&lang=js&"
export * from "./PayCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports